module.exports = __webpack_public_path__ + "img/edit_history_icon.0e5195cc.svg";